import { tableStyles } from "../../components/DataTable";

export const billingPageStyles: Record<string, React.CSSProperties> = {
  ...tableStyles,
  tabBar: {
    display: "flex",
    gap: 4,
    marginBottom: 20,
    borderBottom: "1px solid var(--color-border)",
  },
  tab: {
    padding: "8px 12px",
    fontSize: 13,
    fontWeight: 500,
    border: "none",
    borderBottom: "2px solid transparent",
    color: "var(--color-text-secondary)",
    background: "transparent",
  },
  tabActive: {
    color: "var(--color-primary)",
    borderBottomColor: "var(--color-primary)",
  },
  searchRow: { display: "flex", gap: 8, marginBottom: 24 },
  searchInput: {
    flex: 1,
    maxWidth: 360,
    padding: "8px 12px",
    border: "1px solid var(--color-border)",
    borderRadius: 6,
    fontSize: 14,
  },
  searchBtn: {
    padding: "8px 16px",
    fontSize: 14,
    fontWeight: 500,
    borderRadius: 6,
    background: "var(--color-primary)",
    color: "#fff",
  },
};
